import MaintenanceView from "Maintenance/MaintenanceView.js";
import RaildaysView from "Raildays/RaildaysView.js";
import React from "react";
import {Route, Routes} from "react-router-dom";

import useAuth from "Hooks/useAuth.js";
import useFeatures from "Hooks/useFeatures.js";
import wrapRoute from "Wrappers/RouteWrapper.js";

import Ui404View from "./Ui404View.js";
import UiRoutes from "./UiRoutes.js";

/**
 * UI router
 *
 * The main application router.
 * 
 * @package HOPS
 * @subpackage Ui
 * @copyright Heritage Operations Processing Limited
 */
const UiRouter = () => {

	const {authedAny} = useAuth();
	const {isFeatureEnabled} = useFeatures();

	const getRouteWrapper = route => {
		if (!route.wrapped) {
			route.wrapped = wrapRoute(route);
		}
		return route.wrapped;
	};

	if (isFeatureEnabled("MaintenanceMode")) {
		return (
			<Routes>
				{/** Catchall maintenance route */}
				<Route path="*" element={<MaintenanceView />}/>
			</Routes>
		);
	}
	else if (isFeatureEnabled("RaildaysShell")) {
		return (
			<Routes>
				{/** Catchall maintenance route */}
				<Route path="*" element={<RaildaysView />}/>
			</Routes>
		);
	}
	else {
		return (
			<Routes>
				{UiRoutes.map(route => {

					if (route.feature && !isFeatureEnabled(route.feature)) {
						return null;
					}
					else if (route.publicOnly && authedAny) {
						return null;
					}

					return (
						<Route
							Component={getRouteWrapper(route)}
							key={route.uri}
							index={route.index}
							path={`${route.uri}${route.inexact ? "/*" : ""}`} />
					);

				})}

				{/** Catchall 404 route, even if no routes are declared */}
				<Route path="*" element={<Ui404View />}/>
			</Routes>
		);
	}

};

export default UiRouter;
